<template>
  <div class="policy-content">
    <div class="card">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">总体保费概况</div>
        <div class="sub-title-date">{{ basicDate }}</div>
        <div class="sub-title-date1">当前</div>
      </div>
      <div class="borderpolicy"></div>
      <div
        class="card-item"
        style="display: flex; justify-content: space-around"
      >
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css">日</span>
            <span class="title-css">当日保费 (万)</span>
          </div>
          <div class="card-detail-num">
            {{ TotalPremiumData.curDayAmt | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="TotalPremiumData.dayRate >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="TotalPremiumData.dayRate < 0 ? 'isUp' : 'isDown'"
            >
              {{ TotalPremiumData.dayRate | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail" style="margin-left: 3%">
          <div class="card-detail-title">
            <span class="icon-css is-month">月</span>
            <span class="title-css">当月保费 (万)</span>
          </div>
          <div class="card-detail-num">
            {{ TotalPremiumData.curMonthAmt | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="TotalPremiumData.monthRate >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="TotalPremiumData.monthRate < 0 ? 'isUp' : 'isDown'"
            >
              {{ TotalPremiumData.monthRate | formatPercent }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-line"></div>

      <div
        class="card-item"
        style="margin-top: 0.1rem; display: flex; justify-content: space-around"
      >
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css is-quarter">季</span>
            <span class="title-css">当季保费 (万)</span>
          </div>
          <div class="card-detail-num">
            {{ TotalPremiumData.curQuarterAmt | formatDecimal }}
          </div>
          <div class="card-status aligncenter">
            <div
              class="status-bg marginright"
              v-if="TotalPremiumData.quarterRate >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="TotalPremiumData.quarterRate < 0 ? 'isUp' : 'isDown'"
            >
              {{ TotalPremiumData.quarterRate | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css is-year">年</span>
            <span class="title-css">当年保费 (万)</span>
          </div>
          <div class="card-detail-num">
            {{ TotalPremiumData.curYearAmt | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="TotalPremiumData.yearRate >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="TotalPremiumData.yearRate < 0 ? 'isUp' : 'isDown'"
            >
              {{ TotalPremiumData.yearRate | formatPercent }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="line-chart">
      <LineChart :respPreList1="respPreList22" :respCurList1="respCurList22" />
    </div>
    <div class="card">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">分险种概况</div>
      </div>
      <div class="borderpolicy"></div>
      <div class="card-item" style="height: 0.6rem; text-align: center">
        <div class="card-detail" style="height: 0.6rem; text-align: center">
          <div class="card-detail-title">
            <span
              style="
                color: #739ffa;
                margin-right: 0.02rem;
                font-size: 25px;
                vertical-align: bottom;
              "
              >•</span
            >种植业
          </div>
          <div class="card-detail-num">
            <span>{{ todayBfData.dayBreed | formatDecimal }}</span>
            <span> 万</span>
          </div>
        </div>
        <div class="card-detail" style="margin-left: 3%">
          <div class="card-detail-title">
            <span
              style="
                color: #49dbb7;
                margin-right: 0.02rem;
                font-size: 25px;
                vertical-align: bottom;
              "
              >•</span
            >养殖险
          </div>
          <div class="card-detail-num">
            <span>
              {{ todayBfData.dayPlant | formatDecimal }}
            </span>
            <span> 万</span>
          </div>
        </div>
        <div class="card-detail" style="margin-left: 3%">
          <div class="card-detail-title">
            <span
              style="
                color: #f4d289;
                margin-right: 0.02rem;
                font-size: 25px;
                vertical-align: bottom;
              "
              >•</span
            >林业险
          </div>
          <div class="card-detail-num">
            <span>
              {{ todayBfData.dayForest | formatDecimal }}
            </span>

            <span> 万</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pie-chart">
      <PieChart :pieData11="pieData" />
    </div>

    <div class="pie-chart">
      <lineChartTwo
        :respPreList1="respPreList"
        :respCurList1="respCurList"
        @func="getLineData"
      />
    </div>
    <div class="card" style="padding-bottom: 0.2rem">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">分机构概况</div>
        <div
          class="buttonstyle"
          :class="{ isActive: isMonth }"
          @click="handleChange('1')"
        >
          当月
        </div>
        <div
          class="buttonstyle"
          :class="{ isActive: !isMonth }"
          round
          @click="handleChange('2')"
        >
          当年
        </div>
      </div>
      <div class="borderpolicy" style="margin-bottom: 0.1rem"></div>
      <div class="summaryTable">
        <table class="hoverTable">
          <tr>
            <th scope="comName">机构</th>
            <th scope="curAmount">保费</th>
            <th scope="ratePer">同比</th>
          </tr>
          <tr v-for="(item, index) in tableDataP" :key="index">
            <td>{{ item.comName }}</td>
            <td>{{ item.curAmount | formatDecimal }}万</td>
            <td>
              <img
                :src="toUp"
                style="width: 10px"
                alt=""
                v-if="item.ratePer > 0"
              />
              <img :src="toDown" style="width: 10px" alt="" v-else />
              <span
                :style="{ color: item.ratePer > 0 ? '#31d493' : '#FF6363' }"
                >{{ item.ratePer | formatPercent }}</span
              >
            </td>
          </tr>
        </table>
        <div class="upOrDown">
          <van-icon
            name="arrow-down"
            class="el-icon-caret-bottom"
            v-if="isClose"
            @click="collSpan(1)"
          />
          <van-icon name="arrow-up" v-else @click="collSpan(2)"></van-icon>
        </div>
      </div>
    </div>

    <div class="pie-chart">
      <pieChartThree :tableDataPCopy1="tableDataPCopy" ref="pieChartThree" />
    </div>
    <div class="card" style="padding-bottom: 0.15rem">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">其他概况</div>
      </div>

      <div class="summaryTable">
        <div class="table-detail">
          <div class="table-detail-text">
            <img class="cbnhcount" src="./../images/cbnhcount.png" alt="" />
            承保农户:
            <div style="color: #333; font-weight: bold; margin-left: 0.25rem">
              {{ otherData.suminsured | formatDecimal }} 万户次
            </div>
          </div>
          <div class="table-detail-text">
            <img
              class="cbnhcount"
              src="./../images/cbaccount.png"
              alt=""
            />承保数量:
            <div style="color: #333; font-weight: bold; margin-left: 0.25rem">
              {{ otherData.quantityPlant | formatDecimal }}&nbsp;&nbsp;万亩
            </div>
            <div style="color: #333; font-weight: bold; margin-left: 0.25rem">
              {{ otherData.quantityBreed | formatDecimal }}&nbsp;&nbsp;万头/只
            </div>
          </div>
        </div>

        <table class="hoverTable">
          <tr>
            <th scope="name">应收统计</th>
            <th scope="cost">保费</th>
            <th scope="persent">同比</th>
          </tr>
          <tr v-for="(item, index1) in payTableData" :key="index1">
            <td>{{ item.name }}</td>
            <td>{{ item.cost | formatDecimal }}万</td>
            <td>
              <img
                :src="toUp"
                style="width: 10px"
                alt=""
                v-if="item.persent > 0"
              />
              <img :src="toDown" style="width: 10px" alt="" v-else />
              <span
                :style="{ color: item.persent > 0 ? '#31d493' : '#FF6363' }"
                >{{ item.persent | formatPercent }}</span
              >
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="pie-chart">
      <pieChartFour :otherPieData1="otherPieData" />
    </div>
  </div>
</template>

<script>
import toUp from "./../images/toUp.png";
import toDown from "./../images/todown.png";

import LineChart from "../components/lineChart.vue";
import PieChart from "../components/pieChart.vue";
import lineChartTwo from "../components/lineChartTwo.vue";
import pieChartThree from "../components/pieChartThree.vue";
import pieChartFour from "../components/pieChartFour.vue";

var obj = require("@/api/api.js");

export default {
  components: {
    LineChart,
    PieChart,
    lineChartTwo,
    pieChartThree,
    pieChartFour,
  },
  data() {
    return {
      basicDate: "",
      toUp,
      toDown,
      TotalPremiumData: {},
      totalCData: {},
      todayBfData: {}, //保费概况-当日保费金额模块
      pieData: [],
      respPreList: [],
      respCurList: [],
      respPreList22: [],
      respCurList22: [],
      contrastArray: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ], //1-12月份枚举数组
      isMonth: true,
      isClose: true,
      monthOtherObj: {}, // 除江苏内蒙其他备份（月）
      monthTotalizeObj: {}, // 总计备份（月）
      yearOtherObj: {}, // 除江苏内蒙其他备份（年）
      yearTotalizeObj: {}, // 总计备份（年）
      tableDataP: [],
      tableDataPCopy: [], //pie图使用
      tableDataC: [],
      tableDataCCopy: [], //pie图使用
      otherData: {}, //其他概况数据
      otherPieData: [],
      payTableData: [
        { name: "签单保费", cost: "", persent: "" },
        { name: "实收保费", cost: "", persent: "" },
        { name: "应收保费", cost: "", persent: "" },
      ],
      defaultMenuTab: "",

      loginComCode: "",
    };
  },
  created() {
    console.log(this.$route.query);
    this.initPage();
  },
  methods: {
    formatDate() {
      var time = new Date().getTime() - 24 * 60 * 60 * 1000;
      var yesterday = new Date(time);
      yesterday =
        yesterday.getFullYear() +
        "-" +
        (yesterday.getMonth() + 1 > 9
          ? yesterday.getMonth() + 1
          : "0" + (yesterday.getMonth() + 1)) +
        "-" +
        (yesterday.getDate() > 9
          ? yesterday.getDate()
          : "0" + yesterday.getDate());
      this.basicDate = yesterday;
    },
    // 页面初始化调用
    initPage() {
      this.loginComCode = this.$route.query.comcode;

      this.getTotalPremium();
      this.getLineData({ templateCode: "T01" });
      this.getLineData1();
      this.formatDate();
      this.getInsTableData();
      this.getOtherData();
    },
    // 总体保费概况-数据部分
    getTotalPremium() {
      let queryPolicyFee = obj.queryPolicyFee;
      this.$http
        .post(queryPolicyFee, { comcode: this.loginComCode })
        .then((res) => {
          this.TotalPremiumData = res.data;
        });
    },
    getLineData(params = {}) {
      let queryRiskFee = obj.queryRiskFee;
      // 2022-01-19
      params.comcode = this.loginComCode;
      this.$http.post(queryRiskFee, params).then((res) => {
        this.todayBfData = res.data;
        this.pieData = [
          { name: "养殖业", value: res.data.yearBreed },
          { name: "种植业", value: res.data.yearPlant },
          { name: "森林业", value: res.data.yearForest },
        ];
        this.respPreList = []; // 清空数组
        this.respCurList = []; // 清空数组
        let preArrData = this.washDataMethods(res.data.respPreList);
        let curArrData = this.washDataMethods(res.data.respCurList);
        preArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respPreList.push(formatNum);
        });

        curArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respCurList.push(formatNum);
        });
      });
    },
    // 总体保费概况-折线图部分
    getLineData1(params = {}) {
      let queryRiskFee = obj.queryRiskFee;
      // 2022-01-19
      params.comcode = this.loginComCode;
      this.$http.post(queryRiskFee, params).then((res) => {
        let preArrData = this.washDataMethods(res.data.respPreList);
        let curArrData = this.washDataMethods(res.data.respCurList);
        this.respPreList22 = []; // 清空数组
        this.respCurList22 = []; // 清空数组
        preArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respPreList22.push(formatNum);
        });

        curArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respCurList22.push(formatNum);
        });
      });
    },

    // 公共方法：数据缺少月份补0
    washDataMethods(targetArr) {
      let nowArr = [];
      targetArr.forEach((item) => {
        nowArr.push(Object.keys(item).toString());
      });

      for (var j = 0; j < this.contrastArray.length; j++) {
        let obj1 = {};
        if (nowArr.indexOf(this.contrastArray[j]) == -1) {
          obj1[this.contrastArray[j].toString()] = 0;
          targetArr.push(obj1);
        }
      }
      return targetArr;
    },
    // 切换当年/当月
    handleChange(timeFlag) {
      if (timeFlag == 1) {
        this.isMonth = true;
        this.tableDataP = this.respMonthList;
        this.tableDataPCopy = JSON.parse(sessionStorage.getItem("tableMonthP"));

      } else {
        this.isMonth = false;
        this.tableDataP = this.respYearList;
        this.tableDataPCopy = JSON.parse(sessionStorage.getItem("tableYearP"));
      }
    },
    //获取机构立案表格数据
    getInsTableData() {
      let queryComCodeFee = obj.queryComCodeFee;
      this.$http
        .post(queryComCodeFee, { comcode:  this.loginComCode })
        .then((res) => {
          let result = res.data;
          let respMLength = result.respMonthList.length
          console.log(result)
          if (result.rtnCode == "0000") {
            let respMonthArr = [];
            respMonthArr.push(result.respMonthList[0]);
            respMonthArr.push(result.respMonthList[1]);
            respMonthArr.push(result.respMonthList[2]);
            respMonthArr.push(result.respMonthList[respMLength-1]);
            let respMonthArrP =[]
            respMonthArrP.push(result.respMonthList[0]);
            respMonthArrP.push(result.respMonthList[1]);
            let _newObjMonth  = JSON.parse(JSON.stringify(result.respMonthList[2]) )
            for (let i=3;i<respYLength-2;i++){
              _newObjMonth.curAmount+=result.respMonthList[i].curAmount
            }
            _newObjMonth.comName = '其他'
            console.log(_newObjMonth)
            respMonthArrP.push(_newObjMonth);
            respMonthArrP.push(null);
            sessionStorage.setItem("tableMonthP",JSON.stringify(respMonthArrP));
            this.tableDataPCopy = respMonthArrP
            // this.monthOtherObj = result.respMonthList[15];
            this.monthTotalizeObj = result.respMonthList[respMLength - 1];

            this.respMonthList = respMonthArr;
            this.otherMonthArrayList = result.respMonthList.splice(3, respMLength - 1);

            let respYearArr = []
            let respYLength = result.respYearList.length
            respYearArr.push(result.respYearList[0]);
            respYearArr.push(result.respYearList[1]);
            respYearArr.push(result.respYearList[2]);
            respYearArr.push(result.respYearList[respYLength-1]);
            let respYearArrP =[]
            respYearArrP.push(result.respYearList[0]);
            respYearArrP.push(result.respYearList[1]);
            let _newObjYear  =  JSON.parse(JSON.stringify(result.respYearList[2]) )
            for (let i=3;i<respYLength-2;i++){
              _newObjYear.curAmount+=result.respYearList[i].curAmount
            }
            _newObjYear.comName = '其他'
            console.log(_newObjYear)
            respYearArrP.push(_newObjYear);
            respYearArrP.push(null);
            sessionStorage.setItem("tableYearP",JSON.stringify(respYearArrP));

            // this.yearOtherObj = result.respYearList[16];
            this.yearTotalizeObj = result.respYearList[respYLength-1];

            this.respYearList = respYearArr;
            this.otherYearArrayList = result.respYearList.splice(3, respYLength - 1);
            this.tableDataP = this.respMonthList;
            // this.tableDataPCopy = JSON.parse(JSON.stringify(this.tableDataP));
            sessionStorage.setItem("tableMonth",JSON.stringify(this.respMonthList));
            sessionStorage.setItem("tableYear",JSON.stringify(this.respYearList));
          }
        });
    },
    collSpan(flag) {
      if (flag == 1) {
        if (this.isMonth) {
          this.tableDataP.splice(3, 1)
          this.otherMonthArrayList.map(item => {
            this.tableDataP.push(item)
          })
          // this.tableDataP.push(this.monthTotalizeObj)
        } else {
          this.tableDataP.splice(3, 1)
          this.otherYearArrayList.map(item => {
            this.tableDataP.push(item)
          })
          // this.tableDataP.push(this.yearTotalizeObj)
        }
        this.isClose = false
      } else {
        if (this.isMonth) {
          this.tableDataP.splice(3)
          this.tableDataP.push(this.monthTotalizeObj)
        } else {
          this.tableDataP.splice(3)
          this.tableDataP.push(this.yearTotalizeObj)
        }
        this.isClose = true
      }
    },
    getOtherData() {
      let queryBasicInfo = obj.queryBasicInfo;
      this.$http
        .post(queryBasicInfo, { comcode: this.loginComCode })
        .then((res) => {
          var data = res.data;
          if (data.rtnCode == "0000") {
            this.otherData = {
              suminsured: data.suminsured,
              quantityPlant: data.quantityPlant,
              quantityBreed: data.quantityBreed,
            };
            this.otherPieData = [data.sumAmountSs, data.sumAmountYs];
            this.payTableData[0].cost = data.sumAmountQd;
            this.payTableData[0].persent = data.sumRateQd;
            this.payTableData[1].cost = data.sumAmountSs;
            this.payTableData[1].persent = data.sumRateSs;
            this.payTableData[2].cost = data.sumAmountYs;
            this.payTableData[2].persent = data.sumRateYs;
          }
        });
    },
  },
  filters: {
    formatDecimal: function (value) {
      let decimal = value / 10000;
      return decimal.toFixed(2);
    },
    // 百分比转换
    formatPercent(value) {
      let Percent = value * 100;
      return Percent.toFixed(2) + "%";
    },
  },
};
</script>

<style scoped>
.policy-content {
  width: 100%;
  height: auto;
}

.sub-title {
  width: 100%;
  height: 0.24rem;
  display: flex;
}

.sub-title-bar {
  width: 0.04rem;
  height: 0.16rem;
  background: #31d493;
  position: relative;
  top: 0.04rem;
}

.sub-title-text {
  font-size: 0.16rem;
  font-weight: bold;
  color: #333;
  line-height: 0.24rem;
  height: 0.24rem;
  margin-left: 0.06rem;
}

.sub-title-date {
  margin-left: 0.12rem;
  font-size: 0.14rem;
  color: #999;
  line-height: 0.24rem;
  height: 0.24rem;
}
.sub-title-date1 {
  font-size: 13px;
  color: #fff;
  background: #31d493;
  padding: 3px 6px;
  border-radius: 3px;
  margin-left: 5px;
}

.card {
  width: 100%;
  height: auto;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  border-radius: 0.06rem;
  margin-top: 0.04rem;
  margin-bottom: 0.1rem;
  padding: 0.1rem;
  padding-bottom: 0.05rem;
}

.card-sub-title {
  color: #333;
  font-size: 0.14rem;
  line-height: 0.2rem;
  font-weight: bold;
  padding-bottom: 0.16rem;
}

.card-item {
  width: 100%;
  height: 0.9rem;
  /* display: flex; */
}

.card-detail {
  width: 31%;
  height: 100%;
  float: left;
}

.card-detail-title {
  font-size: 0.12rem;
  color: #666;
  line-height: 0.16rem;
}

.card-detail-num {
  font-weight: Heavy;
  color: #333;
  line-height: 0.25rem;
  margin-top: 0.05rem;
}
.card-detail-num > span:nth-child(1) {
  font-weight: bold;
  font-size: 0.2rem;
}

.card-status {
  color: #de5555;
  width: 100%;
  height: 0.2rem;
  margin-top: 0.05rem;
}
.card-status-green {
  color: #49dbb7;
  width: 100%;
  height: 0.2rem;
  margin-top: 0.05rem;
}

.status-num {
  float: left;
  font-size: 0.14rem;
  line-height: 0.2rem;
}

.up {
  color: #49dbb7;
}

.status-bg {
  float: left;
  width: 0.12rem;
  height: 0.2rem;
  margin-left: 0.06rem;
}

.upImg,
.downImg {
  width: 0.08rem;
}

.status-bg-up {
  float: left;
  width: 0.12rem;
  height: 0.2rem;
  margin-left: 0.06rem;
}

.card-line {
  width: 100%;
  height: 0;
  border-bottom: 0.01rem #eee dashed;
}

.line-chart {
  width: 100%;
  height: 260px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  padding: 0.1rem 0.2rem;
  margin-bottom: 0.16rem;
}

.table-header {
  width: 100%;
  height: 0.44rem;
  background: #f6f8fe;
  padding: 0 0.2rem;
}

.header-text {
  width: 50%;
  height: 100%;
  float: left;
  color: #333;
  font-size: 0.14rem;
  line-height: 0.44rem;
}

.table-content {
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0.06rem;
}

.table-content-item {
  width: 100%;
  height: 0.42rem;
  padding: 0 0.2rem;
}

.item-name {
  width: 50%;
  height: 100%;
  float: left;
  color: #333;
  font-size: 0.14rem;
  line-height: 0.44rem;
}

.item-detail {
  width: 50%;
  height: 100%;
  float: left;
}

.item-total {
  float: left;
  color: #333;
  font-size: 0.12rem;
  line-height: 0.44rem;
  font-weight: bold;
}

.item-percent {
  float: left;
  color: #49dbb7;
  font-size: 0.12rem;
  line-height: 0.44rem;
  margin-left: 0.05rem;
}

.item-bg {
  float: left;
  width: 0.12rem;
  height: 100%;
  margin-left: 0.05rem;
  position: relative;
}

.itemImg {
  width: 0.12rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.item-bg-down {
  float: left;
  width: 0.12rem;
  height: 100%;
  margin-left: 0.05rem;
}

.pie-chart {
  width: 100%;
  height: 2.8rem;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  margin-top: 0.05rem;
  margin-bottom: 0.16rem;
}

.table-detail {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 0.1rem;
  background: #fff;
}

.table-detail-text {
  width: 50%;
  float: left;
  height: auto;
  line-height: 0.24rem;
  font-size: 0.12rem;
  color: #999;
}

.fr {
  float: right;
}

.mgl {
  margin-left: 3%;
}

.border-b {
  border-bottom: 1px dashed #535353;
}

table.hoverTable {
  border-collapse: collapse;
  padding: 15px;
}

table.hoverTable th {
  background-color: #f6f8fe;
  font-weight: bold;
  padding: 8px;
  color: #333;
  font-size: 0.14rem;
}
table.hoverTable tr {
  border-top: 1px solid #eee;
  background: #ffffff;
}
table.hoverTable td {
  font-size: 0.12rem;
  color: #7c8088;
  padding: 0.08rem;
}
.borderpolicy {
  border: 0.01rem solid #eeeeee;
  opacity: 1;
  margin: 0.1rem -0.1rem;
}
.aligncenter {
  display: flex;
  align-items: center;
}
.marginright {
  margin-right: 5px;
}
.icon-css {
  font-size: 13px;
  color: #ffffff;
  background: #31d493;
  padding: 1px 5px;
  border-radius: 3px;
}
.is-month {
  background: #2a8cf1ff;
}
.is-quarter {
  background: #ffac63ff;
}
.is-year {
  background: #ff6363ff;
}
.title-css {
  color: #333333ff;
  font-weight: bold;
}
.isUp {
  color: #ff6363ff;
}
.isDown {
  color: #31d493;
}
.upOrDown {
  width: 100%;
  height: 20px;
  background: #eef1f6;
  text-align: center;
  cursor: pointer;
}
i {
  color: #31d493;
}
.isActive {
  background: #31d493 !important;
  color: #fff !important;
}
.buttonstyle {
  padding: 0.07rem 0.15rem;
  border-radius: 0.2rem;
  text-align: center;
  box-sizing: border-box;
  border: 0.01rem solid #31d493;
  line-height: 1;
  font-size: 0.12rem;
  margin-left: 0.1rem;
  color: #31d493;
}
.cbnhcount {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-right: 0.05rem;
}
td {
  border: 1px solid rgba(238, 238, 238, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/operationSummary/components/policySummary.vue